import http from '@/http'
const URL = '/admin/settings/indication'

export const list = async (params) => {
  const list = (await http.get(URL, { params: params }))
  return list
}

export const show = async (id) => {
  let one = null
  if (id) {
    one = (await http.get(URL + `/${id}`))
  }
  return one
}

export const saveReward = (payload) => {
  let id = ''
  if (payload.id) {
    id = payload.id
  }
  return http.post(URL + `/${id}`, payload)
}

export const changeStatus = () => http.put(URL + `/status`)
export const changeRewardStatus = (payload) => http.put(URL + `/${payload}/status`)

export const orderList = async (payload) => http.put(URL + `/sequence`, payload)

export const deleteReward = async (id) => http.delete(URL + `/${id}`)

export default {
  list,
  show,
  orderList,
  saveReward,
  changeStatus,
  changeRewardStatus,
  deleteReward
}
